import {
  FaUniversity,
  FaHandHoldingUsd,
  FaCoins,
  FaShieldAlt,
  FaExchangeAlt,
  FaFingerprint,
  FaMoneyCheckAlt,
  FaChild,
  FaBriefcase,
  FaStore,
  FaGlobe,
  FaHospital,
  FaCar,
  FaCreditCard, // Import FaCreditCard
  FaMoneyBillWave, // Import FaMoneyBillWave
  FaTags, // Import FaTags
  FaPiggyBank, // Import FaPiggyBank
} from "react-icons/fa";


const servicesData = {
  "Banking Services": {
    category: "Banking Services",
    services: [
      {
        name: "Savings Accounts",
        description:
          "Securely manage your finances with our range of savings account options tailored to your needs. Earn interest while enjoying easy access to your funds.",
        link: "/savings-accounts",
      },
      {
        name: "Current Accounts",
        description:
          "Enjoy the flexibility and convenience of our current account services, designed to meet the dynamic needs of your business.",
        link: "/current-accounts",
      },
      {
        name: "Minor Accounts",
        description:
          "Introduce your children to the world of banking with our minor accounts, designed to teach them financial responsibility from a young age.",
        link: "/minor-accounts",
      },
      {
        name: "Micro ATM (Card Swipe)",
        description:
          "Conduct convenient banking transactions, including cash withdrawals and deposits, using our Micro ATM card swipe facility.",
        link: "/micro-atm",
      },
      {
        name: "AEPS",
        description:
          "Access your bank account and perform transactions securely using your Aadhaar number and biometric authentication through our AEPS service.",
        link: "/aeps",
      },
      {
        name: "Atal Pension Yojana",
        description:
          "Secure your future with the Atal Pension Yojana, a government-backed pension scheme for the unorganized sector.",
        icon: <FaMoneyBillWave />,
        link: "/atal-pension-yojana",
        category: "banking",
      },
      {
        name: "Fixed Deposits",
        description:
          "Grow your savings with our attractive fixed deposit schemes. Enjoy competitive interest rates and flexible tenures.",
        icon: <FaPiggyBank />,
        link: "/fixed-deposits",
        category: "banking",
      },
    ],
  },
  "Loan Services": {
    category: "Loan Services",
    services: [
      {
        name: "Gold Loan Services",
        description:
          "Unlock the value of your gold assets with our hassle-free gold loan services. Get quick access to funds at competitive interest rates.",
        link: "/gold-loans",
      },
      {
        name: "Personal Loans",
        description:
          "Fulfill your personal aspirations with our flexible personal loan options. Whether it's for education, travel, or a medical emergency, we've got you covered.",
        link: "/personal-loans",
      },
      {
        name: "Business Loans",
        description:
          "Fuel your business growth with our tailored business loan solutions. We offer term loans, working capital loans, and other financing options to meet your specific needs.",
        link: "/business-loans",
      },
    ],
  },
  "Payment Services": {
    category: "Payment Services",
    services: [
      {
        name: "Fino Domestic Money Transfer",
        description:
          "Transfer funds instantly and securely to any bank account in India with our Fino Domestic Money Transfer service.",
        link: "/fino-domestic-money-transfer",
      },
      {
        name: "Fino International Money Transfer",
        description:
          "Send money abroad conveniently and securely with our Fino International Money Transfer service, offering competitive exchange rates and fast processing.",
        link: "/fino-international-money-transfer",
      },
      {
        name: "Merchant Services",
        description:
          "Empower your business to accept digital payments with our comprehensive merchant services, including POS machines and payment gateways.",
        link: "/merchant-services",
      },
      {
        name: "Credit Card Bill Payments",
        description:
          "Pay your credit card bills conveniently through our platform. We support all major credit card providers.",
        icon: <FaCreditCard />,
        link: "/credit-card-bill-payments",
        category: "payments",
      },
      {
        name: "FASTags",
        description:
          "Enjoy cashless travel on national highways with our FASTag services. Recharge your FASTag quickly and easily through our platform.",
        icon: <FaTags />,
        link: "/fastags",
        category: "payments",
      },
    ],
  },
  "Insurance Services": {
    category: "Insurance Services",
    services: [
      {
        name: "Life Insurance",
        description:
          "Protect your loved ones and secure their financial future with our comprehensive life insurance plans, offering coverage against various risks.",
        link: "/life-insurance",
      },
      {
        name: "Health Insurance",
        description:
          "Safeguard your health and well-being with our health insurance plans, providing coverage for medical expenses and hospitalization.",
        link: "/health-insurance",
      },
      {
        name: "General Insurance",
        description:
          "Protect your valuable assets, including your home, vehicle, and business, with our wide range of general insurance products.",
        link: "/general-insurance",
      },
    ],
  },
};

export default servicesData;